export const devices = {
  xsmall: `(min-width: 450px)`,
  small: `(min-width: 768px)`,
  medium: `(min-width: 992px)`,
  large: `(min-width: 1024px)`,
  xlarge: `(min-width: 1440px)`
}
